import { EMAIL_JOB_REPORT_URL_V1, CALENDAR_ACCOUNT_MANAGERS_URL } from "../../dataProvider/constant";
import { baseApiInstance, scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const emailJobReport = (formData) => () => {
  return scopeApiInstance.post(EMAIL_JOB_REPORT_URL_V1, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getAccountManagers = (organisationId) => () => {
  let url = `${CALENDAR_ACCOUNT_MANAGERS_URL}?organisation_id=${organisationId}&fetch_all=1`;
  return baseApiInstance.get(url).then((res) => {
    if (res && res.data && res.data.data && res.data.data.account_managers) {
      return Promise.resolve(res.data.data.account_managers);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}